import { useGet } from 'restful-react';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import { useState } from 'react';
import { IListProduct } from '../Products/EditProduct/Tabs/ProductLists/Interfaces/IProductList';
import DraggableProductItem from '../../../Components/DraggableProductItem/DraggableProductItem';
import { AddProductsModal } from '../../../Components/AddProductsModal/AddProductsModal';
import { ConfirmRemoveModal } from '../../../Components/ConfirmRemoveModal/ConfirmRemoveModal';
import { ProductListWrapper } from '../Products/EditProduct/Tabs/ProductLists/Components/ProductListWrapper/ProductListWrapper';
import PageHeader from '../../../Components/PageHeader/PageHeader';
import * as utils from '../../../Utils/SelectableProductsFunctions';
import { Button } from 'antd';
import classes from './AudiovisualProducts.module.scss';
import { AdminContainer } from '../Components/AdminContainer/AdminContainer';
import { LoadingState } from '../../../Components/LoadingState/LoadingState';
import { ConnectionError } from '../../Shop/Components/ConnectionError/ConnectionError';

const AudiovisualProducts = (props: any) => {
  const AUDIO_VISUAL = 'AudioVisual';
  const { loading, refetch } = useGet({
    path: 'frontPageProduct?page=AudioVisual',
    resolve: (data) => {
      setAudiovisualProducts(data.products);
      setInitialProducts(data.products);
    },
  });

  const clearState: IListProduct = {
    name: '',
    id: 0,
  };

  const [confirmRemoveItem, setConfirmRemoveItem] = useState<IListProduct>(clearState);
  const [addProductsModalOpen, setAddProductsModalOpen] = useState(false);
  const [audiovisualProducts, setAudiovisualProducts] = useState<IListProduct[]>([]);
  const [initialProducts, setInitialProducts] = useState<IListProduct[]>([]);
  const [hasMadeChanges, setHasMadeChanges] = useState<boolean>(false);

  // Removes the confirmed item from the list display
  const removeItem = (id: number) => {
    removeAudiovisualProduct(id);
    setConfirmRemoveItem(clearState);
    setHasMadeChanges(true);
  };

  const onUpdateItems = (items: IListProduct[]) => {
    items.forEach((element) => {
      setAudiovisualProducts([...audiovisualProducts, element]);
    });
    setAddProductsModalOpen(false);
    setHasMadeChanges(true);
  };

  // Handle the Drag and drop change, set the products-array to new order
  const handleRLDDChange = (newOrderdArray: IListProduct[]) => {
    setAudiovisualProducts(newOrderdArray);
    setHasMadeChanges(true);
  };

  // Filter products-state to remove the confirmed item
  const removeAudiovisualProduct = (id: number) => {
    let newArray = audiovisualProducts?.filter(function (item: IListProduct) {
      return item.id !== id;
    });
    setAudiovisualProducts(newArray);
  };

  const addAudiovisualProduct = (product: IListProduct) => {
    if (!audiovisualProducts.find((element) => element.productId === product.id)) {
      setAudiovisualProducts([...audiovisualProducts, product]);
      setHasMadeChanges(true);
    } else return;
  };

  const saveOrder = () => {
    utils.updateProducts(
      AUDIO_VISUAL,
      audiovisualProducts.map((p) => p.productId ?? p.id),
      () => {
        refetch();
        setHasMadeChanges(false);
      },
    );
  };

  return (
    <AdminContainer>
      <PageHeader title="Audiovisual Products" />
      <div className={classes.root}>
        <AddProductsModal
          visible={addProductsModalOpen}
          onClose={() => setAddProductsModalOpen(false)}
          onConfirm={(items: IListProduct[]) => onUpdateItems(items)}
          selectedProducts={props.products ?? []}
        />
        <ProductListWrapper
          onAddProducts={() => setAddProductsModalOpen(true)}
          addToList={(items: IListProduct) => addAudiovisualProduct(items)}
        >
          {loading ? (
            <LoadingState text="Loading Audiovisual Products..." />
          ) : audiovisualProducts && audiovisualProducts.length > 0 ? (
            <RLDD
              items={audiovisualProducts}
              onChange={handleRLDDChange}
              itemRenderer={(item: IListProduct, index: number) => {
                return (
                  <DraggableProductItem
                    item={item}
                    itemId={item.id}
                    itemIndex={index}
                    onRemove={(id, name) => setConfirmRemoveItem({ id, name })}
                  />
                );
              }}
            />
          ) : (
            <ConnectionError />
          )}
        </ProductListWrapper>
        <ConfirmRemoveModal
          visible={confirmRemoveItem.id ? true : false}
          onConfirm={() => confirmRemoveItem.id && removeItem(confirmRemoveItem.id)}
          onClose={() => setConfirmRemoveItem(clearState)}
          itemName={confirmRemoveItem.name}
        />
        <div className={classes.sticky}>
          <Button
            onClick={() => {
              setAudiovisualProducts(initialProducts);
              setHasMadeChanges(false);
            }}
            type="link"
            danger
            disabled={!hasMadeChanges}
          >
            Discard changes
          </Button>
          <Button type="primary" onClick={() => saveOrder()} disabled={!hasMadeChanges}>
            Save products
          </Button>
        </div>
      </div>
    </AdminContainer>
  );
};
export default AudiovisualProducts;
